import { TagSearchItemEntity } from '@interpals/api-web';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { TagEntity } from '@interpals/api-web';

import api from 'api';
import { getCurrentLocale } from 'utils/i18n';
import { ReduxState } from 'redux/root-reducer';
import { selectTagSearchResults } from 'redux/tags/selectors';
import { TAG_POPULAR_PSEUDO_CAT_ID } from 'constants/tagCategories';

export const TAGS_SEARCH_LIMIT = 15;

interface SearchTagParams {
    text?: string;
    catId?: string;
}

export const searchTags = createAsyncThunk<TagSearchItemEntity[], SearchTagParams, { state: ReduxState }>(
    'get/tags',
    async (params, { getState }) => {
        const state = getState();
        const { text, catId } = params;

        return (
            await api.searchTag({
                text,
                cat_id: catId === TAG_POPULAR_PSEUDO_CAT_ID ? undefined : catId,
                limit: TAGS_SEARCH_LIMIT,
                offset: selectTagSearchResults(state).length,
                AcceptLanguage: getCurrentLocale(),
            })
        ).data;
    },
);

export const updateUserTags = createAsyncThunk<
    TagEntity[],
    {
        id?: string;
        tagIds: string[];
    }
>('set/tags', async ({ id = 'self', tagIds }) => {
    return (await api.updateUserTags({ id, tag_ids: tagIds.join(',') })).data;
});

export const clearTagSearchResults = createAction('clear/tags');
